angular.module('zc.projects')

.directive 'pieChart', ($translate, AccessStats, Chart) ->
  return {
    restrict: 'E'
    require: '?filters'
    templateUrl: '/templates/projects.analytics/views/directives/pie_chart.html'
    scope:
      filters: '='
      project: '='
    link: (scope, element, attrs) ->
      scope.deviceConfig = Chart.getChartConfig 'pie',
        title:
          text: $translate.instant('projectsAnalytics.directives.pieChart.device')
      scope.newSessionConfig = Chart.getChartConfig 'pie',
        title:
          text: $translate.instant('projectsAnalytics.directives.pieChart.newExisting')

      setSeries = (chartConfig, data) ->
        ###
        NOTE: Need to make change to options for highcharts-ng to understand it
        Because of the stupid behavior of highcharts-ng,
        you need to make change to options even when series and axes change.
        see https://zenclerk.qiita.com/yujiosaka/items/d8a80106d5914eea6164
        ###
        chartConfig.options.rand = Math.random()
        chartConfig.series = [
          type: 'pie'
          innerSize: '50%'
          data: data
        ]

      update = ->
        AccessStats.aggregateByFilter
          apikey: scope.project.apikey
          dimension: 'daily'
        , scope.filters
        .then (access_stats) ->
          setSeries scope.deviceConfig, [
            [$translate.instant('projectsAnalytics.directives.pieChart.pc'), 1 - access_stats[0].mobile_session_rate]
            [$translate.instant('projectsAnalytics.directives.pieChart.sp'), access_stats[0].mobile_session_rate]
          ]
          # newSessions pie
          setSeries scope.newSessionConfig, [
            [$translate.instant('projectsAnalytics.directives.pieChart.newVisit'), 1 - access_stats[0].repeat_session_rate]
            [$translate.instant('projectsAnalytics.directives.pieChart.repeatVisit'), access_stats[0].repeat_session_rate]
          ]

      update()
      scope.$on 'filtersUpdated', update
  }



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.analytics/directives/pie_chart.js.coffee